module.exports = __webpack_public_path__ + "static/btn_032.71758e02.png";